<template>
  <div class="controls">
    <button @click="start" v-if="!dirty" class="button">
      <div class="dashicons dashicons-controls-play" />
    </button>
    <button @click="play" v-else-if="!playing" class="button">
      <div class="dashicons dashicons-controls-play" />
    </button>
    <button @click="pause" v-else class="button">
      <div class="dashicons dashicons-controls-pause" />
    </button>
    <button @click="restart" v-if="dirty" class="button">
      <div class="dashicons dashicons-controls-skipback" />
    </button>
    <progress class="progress" v-if="dirty" :max="duration" :value="currentTime" />
    <audio
      v-if="medium"
      :src="medium.src"
      ref="audio"
      @timeupdate="timeUpdate"
      @canplay="setDuration"
      @play="onPlay"
      @pause="onPause"
      @ended="onEnded"
      preload
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    playing: false,
    currentTime: 0,
    duration: 0,
    dirty: false
  }),
  props: {
    medium: Object
  },
  methods: {
    start() {
      this.dirty = true
      this.play()
    },
    play() {
      this.$refs.audio.volume = this.medium.volume
      this.$refs.audio.play()
    },
    pause() {
      this.$refs.audio.pause()
    },
    restart() {
      this.$refs.audio.currentTime = 0
    },
    setDuration(e) {
      this.duration = e.target.duration
    },
    timeUpdate(e) {
      this.currentTime = e.target.currentTime
    },
    onPlay() {
      this.playing = true
    },
    onPause() {
      this.playing = false
    },
    onEnded() {
      this.playing = false
    },
    toggle () {
      if (!this.playing) {
        this.start()
      } else {
        this.pause()
      }
    }
  },
  computed: {
    volume() {
      return this.medium.volume
    }
  },
  watch: {
    volume(val) {
      this.$refs.audio.volume = val
    }
  }
}
</script>

<style lang="stylus" scoped>
.progress
  appearance none
  width 100%
  height 2px
  position absolute
  bottom 0
  left 0
</style>